// Court Vibes: Versandfortschritt und Produktvorschlaege in der Warenkorb-Seitenleiste.
// Die Schwelle kommt aus window.CV_GRATIS_AB (in Cent) und muss zur Versandregel im Shopify-Admin passen.
// Umbau 20.08.2026 gegen das Zucken: Die alte Fassung hat bei JEDER Drawer-Aenderung alles entfernt
// und neu eingefuegt. Ihr eigenes Neuzeichnen hat den MutationObserver erneut ausgeloest, dadurch
// entfernen/einfuegen im Dauerlauf (sichtbares Springen). Jetzt gilt: eigene DOM-Arbeit wird vom
// Observer ignoriert, bestehende Bloecke werden aktualisiert statt ersetzt, Empfehlungen werden
// pro Produkt nur einmal geladen (Cache) und nur eingesetzt, wenn sie fehlen.
// Ergaenzung 20.08.2026: Versandzeile und echte Gesamtsumme, Rate live aus /cart/shipping_rates.json fuer Deutschland.
(function () {
  var GRATIS_AB = window.CV_GRATIS_AB || 8000;
  var laeuft = false;
  var wartet = null;
  var eigen = false; // true, waehrend dieses Skript selbst am DOM arbeitet
  var recoCache = {}; // product_id -> Empfehlungsliste
  var recoLeer = {}; // product_id -> true, wenn es keine Empfehlungen gibt
  var rateCache = {}; // Warenkorbsumme in Cent -> guenstigste Versandrate in Cent

  function euro(cent) {
    return (cent / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function drawer() {
    return document.querySelector('cart-drawer-component');
  }

  // Ergaenzung 21.10.2026: Houda sah auf der Warenkorbseite /cart (Handy, nach "In den
  // Warenkorb" auf der TPC-Seite wird dorthin weitergeleitet) weder Versandzeile noch
  // Fortschrittsbalken, sondern Shopifys Standardtext "Inkl. Zollgebuehren und Steuern.
  // Versand wird beim Checkout berechnet". Ursache: das Skript arbeitete nur in der
  // Seitenleiste. Jetzt bekommt die Warenkorbseite dieselbe Versandzeile, Summe,
  // denselben Hinweis und denselben Balken. Die Vorschlaege bleiben nur in der Seitenleiste.
  function seite() {
    if (location.pathname.replace(/\/$/, '') !== '/cart') return null;
    var s = document.querySelector('.cart-page');
    var d = drawer();
    if (!s || (d && d.contains(s))) return null;
    return s;
  }

  function wurzeln() {
    var r = [];
    var d = drawer();
    if (d) r.push(d);
    var s = seite();
    if (s) r.push(s);
    return r;
  }

  function zielFuerVersand(wurzel) {
    return wurzel.querySelector('.cart-drawer__items') || wurzel.querySelector('.cart-items__wrapper');
  }

  function eigeneArbeit(fn) {
    eigen = true;
    try { fn(); } finally {
      setTimeout(function () { eigen = false; }, 0);
    }
  }

  function versandAktualisieren(d, ziel, cart) {
    var fehlt = GRATIS_AB - cart.total_price;
    var anteil = Math.min(100, Math.round((cart.total_price / GRATIS_AB) * 100));
    var text =
      fehlt > 0
        ? 'Nur noch <strong>' + euro(fehlt) + '</strong> bis zum kostenlosen Versand'
        : '<strong>Kostenloser Versand</strong> ist erreicht';
    var el = d.querySelector('.cv-ship');
    if (!el) {
      el = document.createElement('div');
      el.className = 'cv-ship';
      el.innerHTML = '<div class="cv-ship__text"></div><div class="cv-ship__bar"><span class="cv-ship__fill"></span></div>';
      ziel.parentNode.insertBefore(el, ziel);
    }
    var t = el.querySelector('.cv-ship__text');
    if (t && t.innerHTML !== text) t.innerHTML = text;
    var f = el.querySelector('.cv-ship__fill');
    if (f) f.style.inlineSize = anteil + '%';
  }

  // Versandkosten und echte Gesamtsumme in der Summenzeile.
  // Die Rate kommt live aus der Storefront-API fuer eine deutsche Adresse, damit die
  // Anzeige auch dann noch stimmt, wenn die Versandregeln im Admin geaendert werden.
  // Es gewinnt die guenstigste Rate, das ist Standard und nicht Express.
  function summeAktualisieren(d, cart, cent) {
    var box = d.querySelector('.cart-totals__container');
    if (!box) return;
    var total = box.querySelector('.cart-totals__total');
    if (!total) return;

    // Shopify nennt die Zeile "Geschaetzter Gesamtbetrag", sie enthaelt aber keinen
    // Versand. Sobald der Versand eigens ausgewiesen wird, ist sie die Zwischensumme.
    var label = total.querySelector('.cart-totals__total-label');
    if (label && label.textContent.trim() !== 'Zwischensumme') label.textContent = 'Zwischensumme';

    var zeile = box.querySelector('.cv-versand');
    if (!zeile) {
      zeile = document.createElement('div');
      zeile.className = 'cart-totals__item cv-versand';
      zeile.innerHTML = '<span class="cv-versand__label">Versand nach Deutschland</span><span class="cv-versand__wert"></span>';
      total.parentNode.insertBefore(zeile, total.nextSibling);
    }
    var gesamt = box.querySelector('.cv-gesamt');
    if (!gesamt) {
      gesamt = document.createElement('div');
      gesamt.className = 'cart-totals__item cv-gesamt';
      gesamt.innerHTML = '<span class="cv-gesamt__label">Gesamt</span><span class="cv-gesamt__wert"></span>';
      zeile.parentNode.insertBefore(gesamt, zeile.nextSibling);
    }

    // Waehrungsformat aus der Theme-Zeile uebernehmen, damit die drei Zeilen
    // dasselbe Muster zeigen. Beispiel "€54,90 EUR" wird zu "€58,89 EUR".
    var musterEl = total.querySelector('.cart-totals__total-value');
    var muster = musterEl ? musterEl.textContent.trim() : '';
    var formatiere = function (c) {
      var zahl = (c / 100).toFixed(2).replace('.', ',');
      return /\d/.test(muster) ? muster.replace(/[\d.,]+/, zahl) : euro(c);
    };

    var wert = cent === 0 ? 'Kostenlos' : formatiere(cent);
    var w = zeile.querySelector('.cv-versand__wert');
    if (w && w.textContent !== wert) w.textContent = wert;
    var g = gesamt.querySelector('.cv-gesamt__wert');
    var gtext = formatiere(cart.total_price + cent);
    if (g && g.textContent !== gtext) g.textContent = gtext;

    var note = box.querySelector('.cart-totals__tax-note small');
    var neu = 'Inkl. MwSt. Bei Lieferung in ein anderes Land wird der Versand im Checkout berechnet.';
    if (note && note.textContent.trim() !== neu) note.textContent = neu;
  }

  function versandkostenHolen(cart) {
    // Nur fuer den deutschen Markt. Der Shop hat einen Laender- und Waehrungs-
    // umschalter. Die Ratenabfrage braucht eine Postleitzahl des jeweiligen
    // Landes, und in einer anderen Waehrung waere der Betrag ohnehin falsch.
    // In allen anderen Faellen bleibt die Shopify-Standardzeile stehen.
    var land = window.Shopify && window.Shopify.country;
    var waehrung = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (land !== 'DE' || waehrung !== 'EUR') return Promise.resolve(null);

    var key = String(cart.total_price);
    if (rateCache[key] !== undefined) return Promise.resolve(rateCache[key]);
    return fetch('/cart/shipping_rates.json?shipping_address%5Bcountry%5D=Germany&shipping_address%5Bzip%5D=10115&shipping_address%5Bprovince%5D=')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var raten = (data && data.shipping_rates) || [];
        if (!raten.length) return null;
        var min = Math.min.apply(null, raten.map(function (r) { return Math.round(parseFloat(r.price) * 100); }));
        rateCache[key] = min;
        return min;
      })
      .catch(function () { return null; });
  }

  function karte(p) {
    var bild = p.featured_image || (p.images && p.images[0]) || '';
    if (bild && bild.indexOf('?') === -1) bild = bild + '?width=160';
    var li = document.createElement('li');
    li.className = 'cv-reco__item';
    li.innerHTML =
      '<a href="' + p.url + '"><img loading="lazy" src="' + bild + '" alt=""><span><span class="cv-reco__name">' +
      p.title + '</span><br><span class="cv-reco__price">' + euro(p.price) + '</span></span></a>';
    return li;
  }

  function recoEinsetzen(d, ziel, liste) {
    if (d.querySelector('.cv-reco')) return;
    var box = document.createElement('div');
    box.className = 'cv-reco';
    box.innerHTML = '<p class="cv-reco__title">Das könnte dir gefallen</p><ul class="cv-reco__list"></ul>';
    var ul = box.querySelector('.cv-reco__list');
    liste.forEach(function (p) { ul.appendChild(karte(p)); });
    ziel.appendChild(box);
  }

  function zeichnen(cart) {
    var alle = wurzeln();
    if (!alle.length) return;
    if (!cart || cart.item_count === 0) {
      eigeneArbeit(function () {
        alle.forEach(function (w) {
          var alt = w.querySelectorAll('.cv-ship, .cv-reco, .cv-versand, .cv-gesamt');
          for (var i = 0; i < alt.length; i++) alt[i].remove();
        });
      });
      return;
    }
    alle.forEach(function (w) {
      var z = zielFuerVersand(w);
      if (z && z.parentNode) eigeneArbeit(function () { versandAktualisieren(w, z, cart); });
    });

    versandkostenHolen(cart).then(function (cent) {
      if (cent === null || cent === undefined) return;
      wurzeln().forEach(function (w) {
        eigeneArbeit(function () { summeAktualisieren(w, cart, cent); });
      });
    });

    var d = drawer();
    if (!d) return;
    var ziel = zielFuerVersand(d);
    if (!ziel || !ziel.parentNode) return;

    var ersteId = cart.items && cart.items[0] && cart.items[0].product_id;
    if (!ersteId) return;
    var imKorb = {};
    for (var j = 0; j < cart.items.length; j++) imKorb[cart.items[j].product_id] = true;

    var einsetzen = function (alle) {
      var liste = alle.filter(function (p) { return !imKorb[p.id]; }).slice(0, 3);
      if (!liste.length) return;
      var d2 = drawer();
      var ziel2 = d2 && zielFuerVersand(d2);
      if (!ziel2) return;
      eigeneArbeit(function () { recoEinsetzen(d2, ziel2, liste); });
    };

    if (recoCache[ersteId]) { einsetzen(recoCache[ersteId]); return; }
    if (recoLeer[ersteId]) return;
    fetch('/recommendations/products.json?product_id=' + ersteId + '&limit=6&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var alle = data.products || [];
        if (!alle.length) { recoLeer[ersteId] = true; return; }
        recoCache[ersteId] = alle;
        einsetzen(alle);
      })
      .catch(function () {});
  }

  function aktualisieren() {
    if (laeuft) return;
    laeuft = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(zeichnen)
      .catch(function () {})
      .then(function () { laeuft = false; });
  }

  function anstossen(ms) {
    if (wartet) clearTimeout(wartet);
    wartet = setTimeout(function () {
      wartet = null;
      aktualisieren();
    }, ms);
  }

  function eigenerKnoten(n) {
    if (!n || n.nodeType !== 1) return true; // Textknoten u.ae. nicht als fremd werten
    if (n.classList && (n.classList.contains('cv-ship') || n.classList.contains('cv-reco') || n.classList.contains('cv-versand') || n.classList.contains('cv-gesamt'))) return true;
    return !!(n.closest && n.closest('.cv-ship, .cv-reco, .cv-versand, .cv-gesamt'));
  }

  function nurEigenes(m) {
    if (m.target && m.target.closest && m.target.closest('.cv-ship, .cv-reco, .cv-versand, .cv-gesamt')) return true;
    if (m.type !== 'childList') return false;
    var k;
    for (k = 0; k < m.addedNodes.length; k++) if (!eigenerKnoten(m.addedNodes[k])) return false;
    for (k = 0; k < m.removedNodes.length; k++) if (!eigenerKnoten(m.removedNodes[k])) return false;
    return m.addedNodes.length + m.removedNodes.length > 0;
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.cart-items__quantity, .cart-drawer, cart-drawer-component')) {
      anstossen(600);
    }
  });

  new MutationObserver(function (muts) {
    if (eigen) return;
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (nurEigenes(m)) continue;
      if (m.type === 'attributes' && m.target.tagName === 'DIALOG' && m.target.open) {
        anstossen(150);
        return;
      }
      if (m.type === 'childList' && m.target.closest && m.target.closest('cart-drawer-component, .cart-page')) {
        anstossen(250);
        return;
      }
      if (m.type === 'childList' && m.target.closest && m.target.closest('.shopify-section') && m.target.querySelector('.cart-page')) {
        anstossen(250);
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });

  if (document.readyState !== 'loading') aktualisieren();
  else document.addEventListener('DOMContentLoaded', aktualisieren);
})();

// ---- Produktseite: Modellwechsel bei Produkten mit unterschiedlichen Groessen je Modell ----
// Gemessen 17.10.2026 am TPC Monheim Vereinsshirt: Modell Herren hat S bis 3XL, Damen 34 bis 44,
// Kinder 104 bis 164. Horizon behaelt beim Klick auf ein anderes Modell die alte Groesse bei.
// Die Kombination gibt es nicht, deshalb wechselten Preis, Bild und Variante nicht, der Knopf
// wirkte tot. Hier wird nach einem Modellwechsel geprueft, ob die Kombination existiert, und
// sonst auf die erste lieferbare Variante dieses Modells umgestellt, bevorzugt in derselben Farbe.
// Horizon rendert den Picker nach jedem Klick neu, deshalb wird in Schritten mit Kontrolle
// nachgeklickt statt einmal blind.
(function () {
  var busy = false, cache = null;
  function handle() { var m = location.pathname.match(/\/products\/([^\/?#]+)/); return m && m[1]; }
  function fsets(vp) { return Array.prototype.slice.call(vp.querySelectorAll('fieldset')); }
  function sel(vp) {
    return fsets(vp).map(function (f) {
      var r = f.querySelector('input[type=radio]:checked'); var s = f.querySelector('select');
      return r ? r.value : (s ? s.value : null);
    });
  }
  function pick(i, val) {
    var vp = document.querySelector('variant-picker'); if (!vp) return;
    var f = fsets(vp)[i]; if (!f) return;
    var r = Array.prototype.slice.call(f.querySelectorAll('input[type=radio]')).filter(function (x) { return x.value === val; })[0];
    if (r) { if (!r.checked) r.click(); return; }
    var s = f.querySelector('select');
    if (s && s.value !== val) { s.value = val; s.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  function ziel(p, s) {
    var ex = p.variants.filter(function (v) { return v.option1 === s[0] && (s[1] == null || v.option2 === s[1]) && (s[2] == null || v.option3 === s[2]); })[0];
    if (ex) return null;
    var c = p.variants.filter(function (v) { return v.option1 === s[0] && (s[1] == null || v.option2 === s[1]); });
    if (!c.length) c = p.variants.filter(function (v) { return v.option1 === s[0]; });
    return c.filter(function (x) { return x.available; })[0] || c[0] || null;
  }
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || inp.type !== 'radio' || busy) return;
    var vp = inp.closest && inp.closest('variant-picker'); if (!vp) return;
    if (fsets(vp).indexOf(inp.closest('fieldset')) !== 0) return;
    var h = handle(); if (!h) return;
    (cache || (cache = fetch('/products/' + h + '.js').then(function (r) { return r.json(); }))).then(function (p) {
      var v = ziel(p, sel(vp)); if (!v) return;
      busy = true; var n = 0;
      (function schritt() {
        var vp2 = document.querySelector('variant-picker'); var s = vp2 ? sel(vp2) : [];
        var ok = s[0] === v.option1 && (v.option2 == null || s[1] === v.option2) && (v.option3 == null || s[2] === v.option3);
        if (ok || n > 4 || !vp2 || s[0] !== v.option1) { busy = false; return; }
        n++;
        if (v.option2 != null && s[1] !== v.option2) pick(1, v.option2);
        else if (v.option3 != null && s[2] !== v.option3) pick(2, v.option3);
        setTimeout(schritt, 700);
      })();
    }).catch(function () { busy = false; });
  });
})();

// ---- Produktseite: Werte sperren, die es beim gewaehlten Modell nicht gibt (17.10.2026) ----
// Horizon zeigt alle Farben und Groessen des Produkts, auch die, die es beim gewaehlten Modell
// nicht gibt (durchgestrichen), und laesst sie trotzdem anklicken. Danach fehlen Preis und Bild.
// Hier werden diese Knoepfe deaktiviert. Sie bleiben sichtbar und durchgestrichen, sind aber
// nicht mehr waehlbar. Nur Kombinationen, die es gar nicht gibt, ausverkaufte bleiben waehlbar.
(function () {
  var prod = null, laden = null, plan = false;
  function handle() { var m = location.pathname.match(/\/products\/([^\/?#]+)/); return m && m[1]; }
  function holen() {
    if (prod) return Promise.resolve(prod);
    var h = handle(); if (!h) return Promise.resolve(null);
    return laden || (laden = fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) { prod = p; return p; }).catch(function () { return null; }));
  }
  function anwenden() {
    plan = false;
    var vp = document.querySelector('variant-picker'); if (!vp || !prod) return;
    var fs = Array.prototype.slice.call(vp.querySelectorAll('fieldset'));
    if (fs.length < 2) return;
    var wahl = fs.map(function (f) { var r = f.querySelector('input[type=radio]:checked'); return r ? r.value : null; });
    fs.forEach(function (f, i) {
      if (i === 0) return;
      Array.prototype.slice.call(f.querySelectorAll('input[type=radio]')).forEach(function (r) {
        var gibt = prod.variants.some(function (v) {
          for (var k = 0; k < i; k++) { if (wahl[k] != null && v['option' + (k + 1)] !== wahl[k]) return false; }
          return v['option' + (i + 1)] === r.value;
        });
        var lab = r.id ? f.querySelector('label[for="' + r.id + '"]') : null;
        if (!gibt && !r.checked) {
          if (!r.disabled) { r.disabled = true; r.dataset.cvGesperrt = '1'; }
          if (lab) { lab.style.pointerEvents = 'none'; lab.style.cursor = 'default'; lab.setAttribute('aria-disabled', 'true'); }
        } else if (r.disabled && r.dataset.cvGesperrt === '1') {
          r.disabled = false; delete r.dataset.cvGesperrt;
          if (lab) { lab.style.pointerEvents = ''; lab.style.cursor = ''; lab.removeAttribute('aria-disabled'); }
        }
      });
    });
  }
  function bald() { if (plan) return; plan = true; holen().then(function () { setTimeout(anwenden, 30); }); }
  if (!handle()) return;
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.closest && t.closest('variant-picker')) { bald(); return; }
      if (t && t.querySelector && t.querySelector('variant-picker')) { bald(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-picker')) bald(); });
  if (document.readyState !== 'loading') bald(); else document.addEventListener('DOMContentLoaded', bald);
})();
